import { ACTIONS } from '../actions/actionTypes';

const INITIAL_STATE = {
    modalOpen: false,
    modalText: null,
    youtubeLink: null,
    type: null,
    callback: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
    case ACTIONS.OPEN_MODAL:
        return {
            ...state,
            modalText: action.payload.text,
            youtubeLink: action.payload.youtubeLink,
            curiosityLink: action.payload.curiosityLink,
            modalOpen: true,
            callback: action.payload.callback
        };
    case ACTIONS.CLOSE_MODAL:
        return {
            ...state,
            modalOpen: false,
            youtubeLink: null,
            curiosityLink: null,
            modalText: null
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/screenReducer.js